import type { ComponentProps } from 'react'

import { cn } from '@/lib/utils'

/**
 * ログイン画面・エラー画面など「中央に1枚パネルを置くだけ」の画面の共通シェル。
 * 560px〜767px・768px以上でのカード化演出（角丸・box-shadow等）は globals.css 側で
 * `.scanner-screen`（本タスクの移行対象外）とセレクタを共有しているため、その部分は
 * globals.css に残し、`login-screen` クラスを引き続きフックとして使う。ここでは
 * 基本レイアウト（中央寄せ・背景グラデーション・セーフエリア余白）だけを
 * Tailwind ユーティリティとして持たせる。
 */
function CenteredScreen({ className, ...props }: ComponentProps<'main'>) {
  return (
    <main
      data-slot="centered-screen"
      className={cn(
        // 下端余白の --viewport-bottom-gap は iOS Chrome 等の viewport 見誤り補正
        // （globals.css の定義コメント参照）。正しく計算するブラウザでは 0px
        'login-screen flex min-h-[100dvh] items-center justify-center overflow-hidden bg-[linear-gradient(160deg,var(--background)_55%,var(--secondary)_55%)] pt-[max(1.5rem,env(safe-area-inset-top))] px-6 pb-[max(1.5rem,calc(env(safe-area-inset-bottom)+var(--viewport-bottom-gap,0px)))] max-[359px]:px-4',
        className,
      )}
      {...props}
    />
  )
}

function CenteredPanel({ className, ...props }: ComponentProps<'section'>) {
  return (
    <section
      data-slot="centered-panel"
      className={cn(
        'login-panel flex w-full max-w-[25rem] flex-col gap-[2.75rem] px-5 py-8 max-[359px]:gap-[1.75rem] max-[359px]:px-1 md:max-w-[32rem]',
        className,
      )}
      {...props}
    />
  )
}

export { CenteredScreen, CenteredPanel }
